import React from 'react';
import MktDefaultTab from 'components/bng/pages/marketplace/tabs/MktDefaultTab';
import GroupKeys from 'components/bng/pages/marketplace/tabs/GroupKeys';

const SERVICES_GROUPS = [
  {
    title: 'marketplaceTab.services',
    desc: 'services.desc',
    key: GroupKeys.SERVICES,
  },
];

export default function MktServicesTab({ ...props }) {
  return <MktDefaultTab className={'MktServicesTab'} groupsToRender={SERVICES_GROUPS} {...props} />;
}
